import React, { useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    TextField,
    MenuItem,
    Button,
    Chip,
    Divider,
    useTheme
} from '@mui/material';

import { LinearProgress } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import { tokens } from '../../theme';

import { useSelector } from 'react-redux';
import { selectSellers } from '../../store/sellers/sellers.selector';
import UserAvatar from '../users/user-avatar'

import {
    IconButton,
    Dialog, DialogTitle, DialogContent, DialogActions,
    Select, InputLabel, FormControl, List, ListItem, ListItemText
} from '@mui/material';
import { Upload, Visibility, Delete } from '@mui/icons-material';

import { djangoApi } from '../../utils/axios/axios.utils';
import Swal from "sweetalert2";
import { CircularProgress } from '@mui/material';


const statuses = ['Todas', 'Ativa', 'Inativa'];

export default function RevendedoresDashboard({ documentsTypes }) {
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('Ativa');
    const sellersData = useSelector(selectSellers);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    console.log('sellers nessa page', sellersData)
    const filteredResellers = sellersData.filter((r) => {
        const statusName = r.firebase_is_active ? 'Ativa' : 'Inativa'
        return (
            (statusFilter === 'Todas' || statusName === statusFilter) &&
            (r.nome || '').toLowerCase().includes(search.toLowerCase())
        );
    });




    const [openModal, setOpenModal] = useState(false);
    const [selectedReseller, setSelectedReseller] = useState(null);
    const [fileType, setFileType] = useState('');
    const [files, setFiles] = useState([]);
    const [isViewOnly, setIsViewOnly] = useState(true);
    const [isLoadingDocument, setIsLoadingDocument] = useState(false);
    const [sendingDoc, setSendingDoc] = useState(false);
    const [deletingFileIndex, setDeletingFileIndex] = useState(null);

    const [filesByReseller, setFilesByReseller] = useState({}); // Simula os arquivos por revendedora



    const handleCloseModal = () => {
        setFiles([]);
        setFileType('');
        setSelectedReseller(null);
        setIsViewOnly(true);
        setOpenModal(false);
    };

    const handleUpload = async () => {
        if (!files.length || !fileType || !selectedReseller) return;

        setSendingDoc(true);

        const formData = new FormData();

        files.forEach((file) => {
            formData.append("documentos", file);
        });

        formData.append("tipo_documento", fileType);

        try {
            const res = await djangoApi.post(
                `sellers/sellers/${selectedReseller.id}/save_users_docs/`,
                formData,
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            if (res.status === 201) {
                const { data, msg, created_count } = res.data;

                Swal.fire({
                    title: 'Sucesso!',
                    text: msg || `${created_count || files.length} arquivo(s) salvo(s) com sucesso.`,
                    icon: 'success',
                });

                setFilesByReseller((prev) => ({
                    ...prev,
                    [selectedReseller.id]: data.map((file) => ({
                        name: getFileNameFromUrl(file.documento),
                        type: file.tipo_documento_nome,
                        url: file.documento,
                        id: file.id
                    }))
                }));

                handleCloseModal();
            } else {
                console.error("Erro ao salvar documento", res.data);
                alert(res.data.msg || "Erro ao salvar documento");
            }
        } catch (error) {
            console.error("Erro ao enviar os arquivos:", error);
            alert("Erro ao enviar os arquivos");
        } finally {
            setSendingDoc(false);
        }
    };

    const handleDeleteFile = async (fileId, index) => {
        setDeletingFileIndex(index); // mostra o spinner para esse item
        try {
            const res = await djangoApi.post(
                `sellers/sellers/${fileId}/delete_user_doc`, {},
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            if (res.status === 200) {
                // Atualiza os arquivos do revendedor no estado
                setFilesByReseller((prev) => {
                    const prevFiles = prev[selectedReseller.id] || [];
                    const updatedFiles = prevFiles.filter(file => file.id !== fileId);
                    return {
                        ...prev,
                        [selectedReseller.id]: updatedFiles
                    };
                });
            }
        } catch (error) {
            console.error("Erro ao deletar o arquivo:", error);
            alert("Erro ao deletar o arquivo");
        } finally {
            setDeletingFileIndex(null); // mostra o spinner para esse item
        }
    }


    function getFileNameFromUrl(url) {
        try {
            const withoutParams = url.split('?')[0]; // Remove tudo após o ?
            const parts = withoutParams.split('/');
            return decodeURIComponent(parts[parts.length - 1]); // Pega o último segmento e decodifica
        } catch (e) {
            console.error("Erro ao extrair nome do arquivo:", e);
            return null;
        }
    }

    const getUserDocs = async (reseller) => {
        setIsLoadingDocument(true)

        // 🧹 Limpa os arquivos do revendedor antes de buscar novamente
        setFilesByReseller((prev) => ({
            ...prev,
            [reseller.id]: []
        }));

        try {
            await djangoApi
                .get(`sellers/sellers/${reseller.id}/get_users_docs/`, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        // 'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    const { data } = res.data;
                    const formattedFiles = data.map((file) => ({
                        name: getFileNameFromUrl(file.documento),
                        type: file.tipo_documento_nome,
                        url: file.documento,
                        id: file.id
                    }));

                    setFilesByReseller((prev) => ({
                        ...prev,
                        [reseller.id]: formattedFiles,
                    }));

                    if (res.status === 200) {
                        // dispatch(setSellers(data))
                        setIsLoadingDocument(false)
                    } else if (res.status === 208) {
                        setIsLoadingDocument(false)
                        const { msg, error } = res.data
                        Swal.fire({
                            title: `${msg}`,
                            text: `${error}!!`,
                            icon: "error",
                        })
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            setIsLoadingDocument(false)
        } finally {
            // pass
            setIsLoadingDocument(false)
        }
    };


    const handleOpenModal = (reseller, viewOnly = false) => {
        setSelectedReseller(reseller);
        setIsViewOnly(viewOnly);
        setFiles([]);
        setFileType('');

        if (viewOnly) {
            getUserDocs(reseller);
        }

        setOpenModal(true);
    };

    const handleOpenFile = async (fileUrlId) => {
        console.log('file id; ', fileUrlId)
        setIsLoadingDocument(true)
        try {
            await djangoApi
                .get(`sellers/sellers/${fileUrlId}/generate_file_url_user_general/`, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        // 'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    const { data } = res.data;
                    if (res.status === 200) {
                        // dispatch(setSellers(data))
                        window.open(data, "_blank")
                        setIsLoadingDocument(false)
                    } else if (res.status === 208) {
                        setIsLoadingDocument(false)
                        const { msg, error } = res.data
                        Swal.fire({
                            title: `${msg}`,
                            text: `${error}!!`,
                            icon: "error",
                        })
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            setIsLoadingDocument(false)
        } finally {
            // pass
            setIsLoadingDocument(false)
        }
    };




    return (
        <Box p={4} pl={2} pt={0}>
            <Typography variant="h4" gutterBottom pb={1}>
                Gestão de Revendedoras
            </Typography>

            <Grid container spacing={2} mb={2}>
                <Grid item xs={12} md={2}>
                    <TextField
                        fullWidth
                        label="Buscar por nome"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>

            <Divider sx={{ marginBottom: '10px' }} />
            <Grid container spacing={3}>
                {filteredResellers.map((reseller) => (
                    <Grid item xs={12} md={4} key={reseller.id}>
                        <Card
                            sx={{
                                borderRadius: '8px',
                                backgroundColor: reseller.firebase_is_active ? colors.pink[800] : colors.pink[600],
                                color: 'white',
                            }}
                            elevation={5}
                        >
                            <CardContent>
                                <Box display="flex" alignItems="center" mb={2}>
                                    <UserAvatar
                                        name={reseller.nome}
                                        sellerId={reseller.id}
                                        seller={reseller}
                                        styleprops={{ width: 56, height: 56, mr: 2, color: 'white' }}
                                        typeOf="card"
                                    />
                                    <Box>
                                        <Typography variant="h6">{reseller.nome}</Typography>
                                        <Typography variant="body2">{reseller.email || 'Sem Email'}</Typography>
                                        <Typography variant="body2">{reseller.telefone || 'Sem Telefone'}</Typography>
                                        <Typography variant="caption" color="white">
                                            {reseller.end_municipio_entrega || 'Sem Endereço'}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Typography variant="body2" gutterBottom>
                                    Total de Vendas: R$ {0.00}
                                </Typography>

                                <Chip
                                    label={reseller.firebase_is_active ? 'Ativa' : 'Inativa'}
                                    color={reseller.firebase_is_active ? 'success' : 'default'}
                                    size="small"
                                    sx={{ mb: 1 }}
                                />

                                <Box display="flex" gap={1} mt={2}>
                                    <IconButton onClick={() => handleOpenModal(reseller)} title="Gerenciar Arquivos">
                                        <Upload sx={{ color: 'white' }} />
                                    </IconButton>
                                    {/* Exemplo de abrir visualização geral */}
                                    {/* {filesByReseller[reseller.id]?.length > 0 && ( */}
                                    <IconButton onClick={() => handleOpenModal(reseller, true)} title="Ver Arquivos">
                                        <Visibility sx={{ color: 'white' }} />
                                    </IconButton>
                                    {/* )} */}

                                </Box>

                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Dialog
                open={openModal}
                onClose={() => {
                    if (!sendingDoc) {
                        handleCloseModal();
                    }
                }}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: colors.primary[900], // fundo escuro do seu sistema
                        color: colors.grey[100],              // texto claro
                        borderRadius: 2,
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        color: colors.grey[100],
                        backgroundColor: colors.pink[700],
                    }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">
                            {isViewOnly ? 'Arquivos Enviados' : 'Enviar Arquivo'}
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                            {selectedReseller?.nome}
                        </Typography>
                    </Box>
                </DialogTitle>

                <DialogContent dividers sx={{ borderColor: colors.grey[600], backgroundColor: colors.pink[500] }}>
                    {(isViewOnly && !selectedReseller) || isLoadingDocument ? (
                        <Typography>Carregando informações...</Typography>
                    ) : isViewOnly ? (
                        (filesByReseller[selectedReseller?.id] || []).length > 0 ? (
                            <List dense>
                                {filesByReseller[selectedReseller.id]
                                    ?.slice() // cria uma cópia para não mutar o original
                                    // .sort((a, b) => {
                                    //     const typeCompare = a?.type?.localeCompare(b?.type);
                                    //     if (typeCompare !== 0) return typeCompare;
                                    //     return a?.name?.localeCompare(b?.name);
                                    // })
                                    .map((file, idx) => (
                                        <ListItem
                                            key={idx}
                                            secondaryAction={
                                                deletingFileIndex === idx ? (
                                                    <CircularProgress size={20} />
                                                ) : (
                                                    <IconButton
                                                        edge="end"
                                                        onClick={() => handleDeleteFile(file.id, idx)}
                                                        sx={{ color: 'red' }}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                )
                                            }
                                        >
                                            <ListItemText
                                                primary={
                                                    <Typography
                                                        onClick={() => handleOpenFile(file.id)}
                                                        sx={{
                                                            color: colors.blueAccent[200],
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            '&:hover': {
                                                                color: colors.grey[200],
                                                            },
                                                        }}
                                                    >
                                                        {file.name}
                                                    </Typography>
                                                }
                                                secondary={
                                                    <Typography component="span" fontWeight="bold">
                                                        {file.type}
                                                    </Typography>
                                                }
                                            />
                                        </ListItem>
                                    ))}
                            </List>
                        ) : (
                            <Typography>Nenhum arquivo enviado ainda.</Typography>
                        )
                    ) : (
                        <>
                            <FormControl fullWidth margin="dense">
                                <InputLabel id="file-type-label" sx={{ color: 'white' }} >
                                    Tipo de Arquivo
                                </InputLabel>
                                <Select
                                    labelId="file-type-label"
                                    value={fileType}
                                    onChange={(e) => setFileType(e.target.value)}
                                    label="Tipo de Arquivo"
                                    sx={{
                                        color: colors.grey[100],
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: colors.grey[200],
                                        },
                                    }}
                                >
                                    {
                                        documentsTypes.map((data, index) => {
                                            return (
                                                <MenuItem key={index} value={data.id}>{data.tipo_documento}</MenuItem>
                                            )
                                        })
                                    }

                                </Select>
                            </FormControl>

                            <TextField
                                fullWidth
                                margin="dense"
                                type="file"
                                onChange={(e) => setFiles(Array.from(e.target.files || []))}
                                inputProps={{
                                    accept: '*',
                                    multiple: true
                                }}
                                sx={{
                                    mt: 2,
                                    color: colors.grey[100],
                                    '& .MuiInputBase-root': {
                                        borderColor: colors.grey[700],
                                        color: colors.grey[100],
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: colors.grey[200],
                                    },
                                }}
                            />

                            {files.length > 0 && (
                                <Box
                                    mt={2}
                                    sx={{
                                        border: `1px solid ${colors.grey[700]}`,
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        backgroundColor: colors.primary[900],
                                    }}
                                >
                                    <Box
                                        px={2}
                                        py={1.5}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        sx={{
                                            borderBottom: `1px solid ${colors.grey[700]}`,
                                            backgroundColor: colors.pink[700],
                                        }}
                                    >
                                        <Typography variant="body2" fontWeight="bold" color={colors.grey[100]}>
                                            Arquivos selecionados
                                        </Typography>

                                        <Chip
                                            size="small"
                                            label={`${files.length} arquivo(s)`}
                                            sx={{
                                                backgroundColor: colors.greenAccent[600],
                                                color: colors.grey[900],
                                                fontWeight: 'bold',
                                            }}
                                        />
                                    </Box>

                                    {sendingDoc && (
                                        <Box px={2} py={1.5}>
                                            <Typography variant="caption" color={colors.grey[100]}>
                                                Enviando documentos, aguarde...
                                            </Typography>

                                            <LinearProgress
                                                sx={{
                                                    mt: 1,
                                                    height: 6,
                                                    borderRadius: 99,
                                                    backgroundColor: colors.grey[700],
                                                    '& .MuiLinearProgress-bar': {
                                                        backgroundColor: colors.greenAccent[500],
                                                    },
                                                }}
                                            />
                                        </Box>
                                    )}

                                    <List dense disablePadding>
                                        {files.map((file, index) => (
                                            <ListItem
                                                key={`${file.name}-${index}`}
                                                sx={{
                                                    py: 1,
                                                    px: 2,
                                                    borderTop: index === 0 ? 'none' : `1px solid ${colors.grey[800]}`,
                                                    opacity: sendingDoc ? 0.75 : 1,
                                                }}
                                            >
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                    gap={1.2}
                                                    width="100%"
                                                >
                                                    {sendingDoc ? (
                                                        <CircularProgress size={18} sx={{ color: colors.greenAccent[400] }} />
                                                    ) : (
                                                        <InsertDriveFileIcon sx={{ fontSize: 20, color: colors.blueAccent[200] }} />
                                                    )}

                                                    <Box flex={1} minWidth={0}>
                                                        <Typography
                                                            variant="body2"
                                                            color={colors.grey[100]}
                                                            noWrap
                                                        >
                                                            {file.name}
                                                        </Typography>

                                                        <Typography variant="caption" color={colors.grey[300]}>
                                                            {(file.size / 1024 / 1024).toFixed(2)} MB
                                                        </Typography>
                                                    </Box>

                                                    {!sendingDoc && (
                                                        <Chip
                                                            size="small"
                                                            label="Pronto"
                                                            sx={{
                                                                backgroundColor: colors.blueAccent[700],
                                                                color: colors.grey[100],
                                                            }}
                                                        />
                                                    )}

                                                    {sendingDoc && (
                                                        <Chip
                                                            size="small"
                                                            label="Enviando"
                                                            sx={{
                                                                backgroundColor: colors.yellow[700],
                                                                color: colors.grey[900],
                                                                fontWeight: 'bold',
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            )}
                        </>
                    )}
                </DialogContent>

                <DialogActions sx={{ backgroundColor: colors.pink[700], borderTop: `1px solid ${colors.grey[700]}` }}>
                    <Button
                        onClick={handleCloseModal}
                        disabled={sendingDoc}
                        variant="outlined"
                        sx={{
                            backgroundColor: colors.yellow[700],
                            color: 'white',
                            borderColor: colors.grey[600],
                            '&:hover': { borderColor: colors.yellow[200] }
                        }}
                    >
                        Fechar
                    </Button>
                    {!isViewOnly && (
                        <Button
                            onClick={handleUpload}
                            variant="contained"
                            disabled={!files.length || !fileType || sendingDoc}
                            sx={{
                                backgroundColor: colors.greenAccent[600],
                                color: colors.grey[900],
                                '&:hover': {
                                    backgroundColor: colors.greenAccent[500],
                                }
                            }}
                        >
                            {sendingDoc ? (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <CircularProgress size={18} sx={{ color: 'white' }} />
                                    <span>Enviando...</span>
                                </Box>
                            ) : (
                                files.length > 1 ? `Enviar ${files.length} arquivos` : "Enviar"
                            )}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
}